import axios from 'axios'
import { getHeader, companyUrl } from './../config'

const state = {
  companyList: []
}

const mutations = {
  SET_COMPANY_LIST (state, obj) {
    state.companyList = obj
  }
}

const actions = {
  getCompanyList: ({ commit }) => {
    axios.get(companyUrl, { headers: getHeader() })
      .then(response => {
        // console.log(response.data.data)
        commit('SET_COMPANY_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
